import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export const ESTIMATE_API_BASE_URL = new InjectionToken<string>('ESTIMATE_API_BASE_URL');

export interface AcknowledgeEstimateDisclaimerRequest {
    encounterId: number;
    acknowledgeName: string;
}

export interface AcknowledgeEstimateDisclaimerResponse {
    acknowledgedEstimateDisclaimerAt: string;
    acknowledgedEstimateDisclaimer: string;
}

@Injectable({ providedIn: 'root' })
export class EstimateApiService {
    private readonly rootUrl: string;

    constructor(
        private readonly http: HttpClient,
        @Optional() @Inject(ESTIMATE_API_BASE_URL) baseUrl?: string,
    ) {
        this.rootUrl = (baseUrl ?? '').replace(/\/$/, '');
    }

    public acknowledgeEstimateDisclaimer(params: AcknowledgeEstimateDisclaimerRequest): Observable<AcknowledgeEstimateDisclaimerResponse> {
        return this.http.post<AcknowledgeEstimateDisclaimerResponse>(
            `${this.rootUrl}/encounter/acknowledgedEstimateDisclaimer/${params.encounterId}`,
            {
                acknowledgeName: params.acknowledgeName,
            },
        );
    }
}
